import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { setSession, formatDetail } from "./api";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PortalLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const resp = await fetch(`${API}/api/client/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(formatDetail(data.detail));
      setSession(data.token, data.refresh_token);
      navigate("/portal");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="noise-overlay relative flex min-h-screen items-center justify-center bg-forest-deep px-4" data-testid="portal-login">
      <div className="absolute -right-40 top-0 h-[480px] w-[480px] rounded-full bg-emerald-500/10 blur-[130px]" />
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-3xl border border-white/10 bg-white p-8 shadow-2xl" data-testid="portal-login-form">
        <img src="/logo-mark.png" alt="CLYMACO" className="h-9 w-auto" />
        <div className="mt-4 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-800/70">EPR Control Portal</div>
        <h1 className="mt-2 font-display text-2xl font-bold text-forest-deep">Client sign in</h1>
        <p className="mt-1 text-sm text-forest-deep/60">One account for your whole organisation, across every regime and stream.</p>
        <label className="mt-6 block text-sm font-semibold text-forest-deep/80">Work email</label>
        <input data-testid="portal-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-lg border border-emerald-950/15 bg-white px-3 py-2.5 text-sm outline-none focus:border-emerald-600" autoComplete="username" />
        <label className="mt-4 block text-sm font-semibold text-forest-deep/80">Password</label>
        <input data-testid="portal-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full rounded-lg border border-emerald-950/15 bg-white px-3 py-2.5 text-sm outline-none focus:border-emerald-600" autoComplete="current-password" />
        {error && (
          <p data-testid="portal-login-error" className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm font-medium text-red-700">
            {error}
          </p>
        )}
        <button data-testid="portal-login-submit" type="submit" disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-forest-primary py-3 font-display text-sm font-bold text-white transition-colors hover:bg-forest-rich disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          Sign in
        </button>
        <p className="mt-4 text-center text-xs text-forest-deep/50">Password help is handled by Clymaco staff.</p>
      </form>
    </main>
  );
}
